import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DropdownIcon = function DropdownIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7071 0.292986C11.3166 -0.097538 10.6834 -0.097538 10.2929 0.292986L6 4.58588L1.70711 0.292986C1.31658 -0.0975381 0.683417 -0.0975381 0.292893 0.292986C-0.0976314 0.68351 -0.0976314 1.31668 0.292893 1.7072L6 7.41431L11.7071 1.7072C12.0976 1.31668 12.0976 0.68351 11.7071 0.292986Z",
      fill: "#12131A"
    })
  }));
};

DropdownIcon.defaultProps = {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const AccordionFormGroupPanel = _ref => {
  let {
    title,
    className,
    isOpen = false,
    isToggleable = true,
    onClick = () => undefined,
    children
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [title || isToggleable ? /*#__PURE__*/_jsxs("header", _objectSpread(_objectSpread({
      className: clsx(styles.panelHeading, isOpen ? styles['panelHeading--open'] : '', isToggleable ? styles['panelHeading--toggleable'] : '')
    }, isToggleable && {
      onMouseDown: onClick
    }), {}, {
      children: [title ? /*#__PURE__*/_jsx("h6", {
        className: styles.panelHeading__text,
        children: title
      }) : /*#__PURE__*/_jsx(_Fragment, {}), isToggleable && /*#__PURE__*/_jsx("button", {
        className: styles.panelHeading__icon,
        type: "button",
        children: /*#__PURE__*/_jsx(DropdownIcon, {})
      })]
    })) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx("div", {
      className: clsx(styles.panelContent, className || '', isOpen ? styles['panelContent--open'] : ''),
      children: children
    })]
  });
};

export default AccordionFormGroupPanel;